import { Logtail as Browser } from "@logtail/browser"
import { getSession } from "next-auth/react"

const logtail = new Browser(process.env.NEXT_PUBLIC_LOGTAIL_SOURCE_TOKEN)

// add metadata to log entry
async function enrichLogs(log) {
    const session = await getSession()
    return {
        ...log,
        session: {
            hasSession: !!session,
            email: session?.user?.email,
            oktaId: session?.user?.oktaId,
        },
    }
}

// add middleware
logtail.use(enrichLogs)

export default logtail
